<template>
  <a v-if="$store.getters.isAuthenticated" href="#" @click.prevent="onClick">
    <span class="d-inline-flex align-items-center">
      <em v-if="showIcon" class="fal fa-sign-out" :class="{ 'mr-1': text }" />
      <span>
        <slot>
          {{ text }}
        </slot>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: "LogoutButton",
  props: {
    text: {
      type: String,
      required: false,
      default: "",
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["logout"],
  methods: {
    async onClick() {
      await this.$store.dispatch("logout");
      this.$emit("logout");
    },
  },
};
</script>
